import { css } from '@/styled-system/css';

export const triggerTextStyles = css.raw({
  display: 'inline-flex',
  color: 'inherit',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  userSelect: 'text',
  padding: 'none',
  borderBlockEndColor: 'TriggerText.border.default',
  borderBlockEndWidth: 'default',
  borderBlockEndStyle: 'dashed',

  _focusVisible: {
    boxShadow: 'focus',
  },

  _hover: {
    borderBlockEndColor: 'TriggerText.border.hover',
  },

  _active: {
    borderBlockEndColor: 'TriggerText.border.pressed',
  },
});
